/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteShiftsRequestAdmin } from '../models/DeleteShiftsRequestAdmin';
import type { DriverShiftAdminDto } from '../models/DriverShiftAdminDto';
import type { DriverShiftDriverDto } from '../models/DriverShiftDriverDto';
import type { GetAllShiftsAdminResponse } from '../models/GetAllShiftsAdminResponse';
import type { GetAvailableShiftsDriverResponse } from '../models/GetAvailableShiftsDriverResponse';
import type { GetBookedShiftsDriverResponse } from '../models/GetBookedShiftsDriverResponse';
import type { Pagination1OfShiftAdminDto } from '../models/Pagination1OfShiftAdminDto';
import type { PostPutShiftRequestAdmin } from '../models/PostPutShiftRequestAdmin';
import type { PostShiftAcquireAdminRequest } from '../models/PostShiftAcquireAdminRequest';
import type { PostShiftAcquireDriverRequest } from '../models/PostShiftAcquireDriverRequest';
import type { PostShiftReleaseAdminRequest } from '../models/PostShiftReleaseAdminRequest';
import type { PostShiftReleaseDriverRequest } from '../models/PostShiftReleaseDriverRequest';
import type { PostShiftTemplateActivationRequestAdmin } from '../models/PostShiftTemplateActivationRequestAdmin';
import type { PostStartGenerateShiftJobAdminRequest } from '../models/PostStartGenerateShiftJobAdminRequest';
import type { ShiftAdminDto } from '../models/ShiftAdminDto';
import type { ShiftType } from '../models/ShiftType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftsService {
    /**
     * @returns GetAvailableShiftsDriverResponse OK
     * @throws ApiError
     */
    public static getAvailableShiftsDriver({
        fromDate,
        toDate,
    }: {
        fromDate: string,
        toDate: string,
    }): CancelablePromise<GetAvailableShiftsDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shifts/available',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverShiftDriverDto OK
     * @throws ApiError
     */
    public static postAcquireShiftDriver({
        requestBody,
    }: {
        requestBody?: PostShiftAcquireDriverRequest,
    }): CancelablePromise<DriverShiftDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shifts/acquire',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postReleaseShiftDriver({
        requestBody,
    }: {
        requestBody?: PostShiftReleaseDriverRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shifts/release',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetBookedShiftsDriverResponse OK
     * @throws ApiError
     */
    public static getBookedShiftsDriver({
        fromDate,
        toDate,
    }: {
        fromDate: string,
        toDate: string,
    }): CancelablePromise<GetBookedShiftsDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shifts/booked',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ActivateShiftTemplates`
     * @returns any OK
     * @throws ApiError
     */
    public static postShiftAdmin({
        requestBody,
    }: {
        requestBody?: PostShiftTemplateActivationRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shifts/template-activation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShifts`
     * @returns ShiftAdminDto OK
     * @throws ApiError
     */
    public static postShiftAdmin1({
        requestBody,
    }: {
        requestBody?: PostPutShiftRequestAdmin,
    }): CancelablePromise<ShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shifts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShifts`
     * @returns Pagination1OfShiftAdminDto OK
     * @throws ApiError
     */
    public static getShiftsAdmin({
        fromStartDateTime,
        toStartDateTime,
        fromDuration,
        toDuration,
        minSize,
        maxSize,
        type,
        regionId,
        page,
        limit,
    }: {
        fromStartDateTime?: string,
        toStartDateTime?: string,
        fromDuration?: string,
        toDuration?: string,
        minSize?: number,
        maxSize?: number,
        type?: ShiftType,
        regionId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shifts',
            query: {
                'fromStartDateTime': fromStartDateTime,
                'toStartDateTime': toStartDateTime,
                'fromDuration': fromDuration,
                'toDuration': toDuration,
                'minSize': minSize,
                'maxSize': maxSize,
                'type': type,
                'regionId': regionId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteShifts`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteShiftsAdmin({
        requestBody,
    }: {
        requestBody?: DeleteShiftsRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/shifts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverShifts`
     * @returns DriverShiftAdminDto OK
     * @throws ApiError
     */
    public static postAcquireShiftAdmin({
        requestBody,
    }: {
        requestBody?: PostShiftAcquireAdminRequest,
    }): CancelablePromise<DriverShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shifts/acquire',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ReleaseDriverShifts`
     * @returns any OK
     * @throws ApiError
     */
    public static postReleaseShiftAdmin({
        requestBody,
    }: {
        requestBody?: PostShiftReleaseAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shifts/release',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShifts`
     * @returns ShiftAdminDto OK
     * @throws ApiError
     */
    public static getShiftAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shifts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShifts`
     * @returns ShiftAdminDto OK
     * @throws ApiError
     */
    public static putShiftAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostPutShiftRequestAdmin,
    }): CancelablePromise<ShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/shifts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ActivateShiftTemplates`
     * @returns ShiftAdminDto OK
     * @throws ApiError
     */
    public static postShiftJobStartAdmin({
        requestBody,
    }: {
        requestBody?: PostStartGenerateShiftJobAdminRequest,
    }): CancelablePromise<ShiftAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shifts/job-start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShifts`
     * @returns GetAllShiftsAdminResponse OK
     * @throws ApiError
     */
    public static getAllShiftsAdmin({
        regionId,
        fromStartDateTime,
        toStartDateTime,
    }: {
        regionId?: number,
        fromStartDateTime?: string,
        toStartDateTime?: string,
    }): CancelablePromise<GetAllShiftsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shifts/all',
            query: {
                'regionId': regionId,
                'fromStartDateTime': fromStartDateTime,
                'toStartDateTime': toStartDateTime,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteShifts`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteAllShiftsAdmin(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/shifts/all',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
